import {
  formSpecification as commonFormSpecification,
  type RecordPolicePresenceFormData as CommonRecordPolicePresenceFormData,
} from "../common/recordPolicePresence/officerRecordedResponseYes.js";

export const formSpecification = commonFormSpecification;

export type RecordPolicePresenceFormData = CommonRecordPolicePresenceFormData;
